"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { capturePostHogEvent } from "@/lib/posthog";
import { readReferralCode } from "@/lib/referral";

// The sticky pill a friend sees after landing on /r/{code}. Copy verbatim from the brief. Hidden on
// the checkout (the discount line says it there) and on the order page (they have bought).
export function ReferralBanner() {
  const pathname = usePathname();
  const [code, setCode] = useState<string | null>(null);

  useEffect(() => {
    const found = readReferralCode();
    setCode(found ?? null);
    if (!found) return;
    try {
      const key = `vellum_referral_seen_${found}`;
      if (!window.sessionStorage.getItem(key)) {
        window.sessionStorage.setItem(key, "1");
        capturePostHogEvent("referral_landing", { referral_code: found });
      }
    } catch {
      // sessionStorage unavailable: the landing is still counted server-side by /r/{code}.
    }
  }, []);

  if (!code) return null;
  if (/\/(checkout|order|account|admin)(\/|$)/.test(pathname ?? "")) return null;

  return (
    <div
      className="sticky top-0 z-30 border-b border-rule bg-accent-wash text-ink"
      data-referral-code={code}
      data-testid="referral-banner"
      role="status"
    >
      <p className="mx-auto flex max-w-page flex-wrap items-baseline justify-center gap-x-2 gap-y-0.5 px-4 py-2 text-center font-sans text-sm md:px-6 lg:px-12">
        <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-accent">10% friend discount applied</span>
        <span className="hidden text-ink-faint sm:inline">-</span>
        <span className="text-ink-soft">Enjoy 10% off your first custom print at checkout.</span>
      </p>
    </div>
  );
}
